











import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
class ActionProcessOrder extends Vue {
  @Getter("market/processOrderBtnVisible") processOrderBtnVisible;

  get meta() {
    return {
      show: this.processOrderBtnVisible
    };
  }

  handleToOrders() {
    this.$common.utils.helper.toFusionPath(this, "trade", { name: "orders" });
  }
}
export default ActionProcessOrder;
